<template>
  <div id="cv--wrapper" :style="styles" >
    <call-bar v-show="$store.state.callActive" />

    <div v-if="isChatSelected">
      <drop @drop="handleDrop">
        <div class="cv--main" :class="mainClass">
          <v-toolbar 
            class="chat-toolbar"
            flat 
            :extended="search"
          >
            <v-toolbar-title class="text-sm-center" id="cv-title"><a @click="openChatDetails" class="cv-link">{{title}}</a></v-toolbar-title>
            <v-spacer></v-spacer>
            
            <v-btn icon class="cv-btn" @click="toggleSearch">
              <v-icon :class="search ? activeClass : ''">search</v-icon>
            </v-btn>

            <v-btn icon class="cv-btn" @click="openAddUsers" v-if="!this.$store.state.currentChat.single">
              <v-icon>person_add</v-icon>
            </v-btn>
            <v-btn icon class="cv-btn" @click="call" v-else-if="!readOnly">
              <v-icon>call</v-icon>
            </v-btn>
            
            <time-selector :value="this.$store.state.currentChat.ttl" v-if="!readOnly" />

            <v-menu bottom left offset-y>
              <v-btn icon slot="activator" class="cv-btn">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in menu"
                  :key="index"
                  @click="menuItemClicked(item.id)"
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu> 

            <template v-slot:extension v-if="search || showAddToContact" >
              <v-layout column>
                <div v-if="search">
                  <v-layout row align-center>
                    <search :searchFilter.sync="searchFilter" ref="searchbox" id="chat-search" />
                    <v-btn icon class="cv-btn" @click="searchUp" :title="$t('search_previous')">
                      <v-icon>keyboard_arrow_up</v-icon>
                    </v-btn>
                    <v-btn icon class="cv-btn" @click="searchDown" :title="$t('search_next')">
                      <v-icon>keyboard_arrow_down</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
                <div v-if="!readOnly && showAddToContact">
                  <v-layout row align-center>
                    <div>{{$t('notification_chat_unknown')}}</div>
                    <v-spacer/>
                    <v-btn icon class="cv-btn" @click="addToContacts" :title="$t('contacts_add')">
                      <v-icon>person_add</v-icon>
                    </v-btn>
                    <v-btn icon class="cv-btn" @click="blockAndDelete" :title="$t('notification_chat_unknown_block')">
                      <v-icon>block</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
              </v-layout>
            </template>
          </v-toolbar>

          <content-view class="cv--content-view" ref="content" :searchable="searchFilter" />
          <typing-view class="cv--typing-view" ref="typingView" v-show="!readOnly" />
        </div>

        <div id="dragover" ref="dragover">
          <v-layout fill-height align-center justify-center>
            <span class="first-screen">{{$t('drag_contact')}}</span>
          </v-layout>
        </div>
      </drop>

      <AddChat :visible.sync="showAddUsers" append :contacts="this.$store.state.currentChat.users" />

    </div>
    <!-- else --> 
    <div v-else style="height:100%; width:100%;">
      <v-layout row justify-center :style="centered">
        <span class="first-screen">{{$t('first_screen')}}</span>
      </v-layout>
    </div>

  </div>
</template>

<style>
  #dragover{
    position: absolute;
    background-color: var(--v-secondary-lighten4);
    z-index: 10;
    opacity: 0.8;
    visibility: hidden;
    width:70%;
    height: 100%;
  }

  #cv--wrapper {
    height: calc(100vh - var(--system-bar-height));
    width: 100%;
    border-left-width: thin;
    border-left-style: solid;
    border-left-color: var(--divider-color);
    background-color: var(--chat-background);
    box-sizing: border-box;
  }
  .cv--fix-height-when-call {
    height: calc(100vh - var(--system-bar-height) - 48px) !important;
  }
  
  .cv--main {
    height: calc(100vh - var(--system-bar-height));
    display: flex;
    flex-direction: column;
  }
  .cv--main .v-toolbar__extension {
    align-items: baseline;
    margin-top: -4px;
    height: unset !important;
  }
  .v-toolbar__extension {
    padding: 0 17px !important;
  }

  .cv--main .v-toolbar__extension .activeClass {
    color: var(--v-primary-base) !important;
  }

  .cv--content-view {
    flex-grow: 1;
    overflow-y: auto;
  }
  .cv--typing-view {
    flex-shrink: 0;
  }
  
  .first-screen {
    border-radius: 16px;
    background-color: var(--nav-background);
    padding: 6px 12px;
    opacity:0.9;
  }

  #cv-title {
    user-select: none;
  }
  #cv-title a {
    color: var(--v-alternativeBackground-base);
  }
  #cv-title a:hover {
    color:var(--v-accent-base);
  }
  .cv-btn {
    padding: 0;
    margin: 8px 0 8px 8px;
    color: var(--v-alternativeBackground-base) !important;
  }

  .cv-link .emoji {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align:middle;
    position: relative;
    top: -2px;
  }

  .chat-toolbar {
    padding:3px 0 !important; 
    border-bottom:1px solid var(--divider-color);
    background-color:var(--chat-toolbar-background) !important;
    color:var(--v-base-additionalBackground-base);
  }
  
  #chat-search .cv-btn {
    padding: 0;
    margin: 0;
    color: var(--v-alternativeBackground-base) !important;
  }

</style>

<script>
  import CallBar from './call/CallBar.vue'
  import ContentView from './chat/ContentView.vue'
  import TypingView from './chat/TypingView.vue'
  import Search from '@common/Search.vue'
  import AddChat from '@dialogs/AddChat.vue'
  import TimeSelector from '@dialogs/TimeSelector.vue'
  import {Events} from '@/core-consts'
  import {EventBus} from '@/event-bus'

  const MenuId = Object.freeze({
    mute: 0,
    clear: 1,
    leave: 2,
  })

  export default {
    name: 'chat-view',
    components: { ContentView, TypingView, TimeSelector, AddChat, Search, CallBar },
    data () {
      return {
        title: '',
        menu: [
          { title: this.$t('chat_menu_mute'), id: MenuId.mute },
          { title: this.$t('chat_menu_clear_history'), id: MenuId.clear  },
          { title: this.$t('chat_menu_leave_chat'), id: MenuId.leave  },
        ],
        showAddUsers: false,
        openCall: false,
        currentChatId: -1,
        chatMuted: false,
        search: false,
        searchFilter: '',
        activeClass: 'activeClass',
        background: this.$store.getters.getChatBackground,
        readOnly: false
      }
    },
    mounted() {
      EventBus.$on('chat-selected', () => {
        // fix: we need some delay for rendering to get $refs.content 
        ///setTimeout(this.chatSelected, 50)
        this.$nextTick(() => {
          this.chatSelected()
        })
      })
      EventBus.$on('chat-message-updated', this.chatMessageUpdated)
      EventBus.$on('chat-typing-updated', this.chatTypingUpdated)
      EventBus.$on('focused', this.focusChanged)
      EventBus.$on('chat-background-changed', () => {
        this.background = this.$store.state.settings.background
        console.log('-- chat-background-changed', this.background)
      })
    },
    beforeDestroy() {
      EventBus.$off('chat-selected')
      EventBus.$off('chat-message-updated')
      EventBus.$off('chat-typing-updated')
      EventBus.$off('chat-background-changed')
    },
    computed: {
      isChatSelected() {
        return (this.$store.state.currentChat.chatId != null)
      },
      showAddToContact() {
        let chat = this.$store.state.currentChat
        if (this.isChatSelected && chat.single && chat.chatId == this.currentChatId) {
          let contacts = this.$store.state.contacts.filter(it => it.contactId.match(chat.users[0]))
          if (contacts.length == 0)
            return true
        }
        return false
      },
      styles() {
        let s = {
          'background-repeat': 'no-repeat',
          'background-size': 'cover',
          'font-size': this.$store.getters.getFontSize + 'px'
        }
        if (this.background) {
          s['background-image'] = 'url( file:///' + this.background + ')'
        }
        return s
      },
      mainClass() {
        return this.$store.state.callActive ? ['cv--fix-height-when-call'] : []
      },
      centered() {
        return {
          'position': 'relative',
          'top': this.$store.state.callActive ? 'calc(50% - 48px - 37px)' : 'calc(50% - 37px)'
        }
      }
    },
    updated() {
      let wrapper = document.getElementById("cv--wrapper").getBoundingClientRect()
      if (this.$refs.dragover) {
        this.$refs.dragover.style.top  = wrapper.top
        this.$refs.dragover.style.left = wrapper.left
      }
    },
    methods: {
      chatSelected() {
        if (this.currentChatId != -1) {
          this.$store.dispatch('toggleTimerMonitoring', {chatId: this.currentChatId, monitorChat: false})
          this.$refs.typingView.storeDraft(this.currentChatId)
        }

        const chat = this.$store.state.currentChat
        this.currentChatId = chat.chatId
        this.title = chat.title
        this.readOnly = chat.readonly
        this.chatMuted = chat.muted
        this.setMuteMenu()

        this.$refs.content.reload()
        this.$refs.typingView.restoreDraft(this.currentChatId)

        this.$nextTick(() => {
          let $el = document.querySelector('a.cv-link')
          $el.innerHTML = this.replaceEmoji(this.title)
        })

        this.$store.dispatch('unreadCountChanged')
      },
      chatChanged(args) {
        // ignore all events if current chat invisible
        const chat = this.$store.state.currentChat
        if (chat.chatId !== args.chatId)
          return

        console.log('(chat) chatChanged: ' + JSON.stringify(args))
        if (args.action == Events.ChatMessageReceived) {
          this.$refs.content.messageReceived(args.messageId, args.chatId)
        } else if (args.action == Events.ChatDetailsChanged) {
          this.title = this.$store.state.currentChat.title
          let $el = document.querySelector('a.cv-link')
          $el.innerHTML = this.replaceEmoji(this.title)

          this.$refs.content.reload()
        } else {
          this.$refs.content.reload()
        }
      },
      updateTtlMessageProgress(args){
        this.$refs.content.updateTtlMessageProgress(args)
      },
      chatMessageUpdated(args) {
        let chat = this.$store.state.currentChat
        if (chat.chatId === args.chatId)
          this.$refs.content.chatMessageUpdated(args.messageId)
      },
      chatTypingUpdated(ev) {
        let chat = this.$store.state.currentChat
        if (chat.chatId === ev.chatId) {
          this.$store.dispatch('fetchUserProfile', ev.contactId).then((resp) => {
            this.$refs.content.chatTypingUpdated(resp.name, resp.avatar, ev.type)
          })         
        }
      },
      handleDrop(data, event) {
        console.log(`You dropped with data: ${JSON.stringify(data)}`);
        this.$store.dispatch('sendMessage', { 
          content: data.contactId,
          type: this.types.ContactMessage
        })
      },
      setMuteMenu() {
        let title = this.chatMuted ? this.$t('chat_menu_unmute') : this.$t('chat_menu_mute')
        this.$set(this.menu, 0, { title: title, id: MenuId.mute }) 
      },
      menuItemClicked(itemId) {
        switch (itemId) {
          case MenuId.mute:
            this.$store.dispatch('setChatMuted').then(() => {
              console.log("after setChatMuted - muted:" + this.$store.state.currentChat.muted)
              this.chatMuted = this.$store.state.currentChat.muted
              this.setMuteMenu()
            })
            break
          case MenuId.clear:
            this.clearChat()
            break
          case MenuId.leave:
            this.leaveChat()
            break
          default:
            return
        }

      },
      clearChat() {
        const cid = this.$store.state.currentChat.chatId
        this.$store.dispatch('clearHistory', cid).then(() => {
          this.$refs.content.reload()
        })
      },
      leaveChat() {
        const cid = this.$store.state.currentChat.chatId
        this.$store.dispatch('leaveChat', cid)       
      },
      call() {
        const users = this.$store.state.currentChat.users
        this.$store.dispatch('call', users).then(() => {
          console.log('-- called')
        })
      },
      openChatDetails() {
        const cid = this.$store.state.currentChat.chatId
        if (!this.readOnly)
          EventBus.$emit('open-chat-details', cid)
      },
      openAddUsers(e) {
        e.stopPropagation()
        this.showAddUsers = true
      },
      focusChanged() {
        if (this.$refs.content && this.currentChatId != -1)
          this.$refs.content.focusChanged()
      },
      searchUp() {
        this.$refs.content.searchUp()
      },
      searchDown() {
        this.$refs.content.searchDown()
      },
      toggleSearch() {
        this.search = !this.search
        if (this.search) {
          this.$nextTick(() => this.$refs.searchbox.focus())
        }
      },
      addToContacts(e) {
        // to fix auto close of contact dialog
        e.stopPropagation()
        this.$store.dispatch('showAddContact', this.$store.state.currentChat.users[0])
      },
      blockAndDelete() {
        this.$store.dispatch('blockContact', this.$store.state.currentChat.users[0])
        this.$store.dispatch('deleteChat', this.$store.state.currentChat.chatId).then(() => {
          EventBus.$emit('chat-deleted')
        })
      },
    }
  }
</script>